export default __webpack_public_path__ + "static/media/login_background.1a8f053b.jpg";